module.exports = __webpack_public_path__ + "img/manutd.a3448c2e.jpg";